import { render, staticRenderFns } from "./FormHotAlertClose.vue?vue&type=template&id=4dc690ad&"
import script from "./FormHotAlertClose.vue?vue&type=script&lang=js&"
export * from "./FormHotAlertClose.vue?vue&type=script&lang=js&"
import style0 from "./FormHotAlertClose.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports